/**
 * Maps raw publisher metadata field keys to user-friendly display labels.
 * Used by EntityMetadataDetails to render readable names instead of camelCase API keys.
 */

export const METADATA_FIELD_LABELS: Record<string, string> = {
  // Campaign fields
  name: 'Name',
  budgetResourceName: 'Budget Resource',
  amountMicros: 'Budget Amount (micros)',
  totalAmountMicros: 'Total Budget (micros)',
  biddingStrategy: 'Bidding Strategy',
  type: 'Type',
  targetCpaMicros: 'Target CPA (micros)',
  endDateTime: 'End Date',

  // Ad Group fields
  adGroupConfigId: 'Ad Group Config ID',
  channelControls: 'Channel Controls',
  selected_channels: 'Selected Channels',
  status: 'Status',
  useAudienceGrouped: 'Use Audience Grouped',
  targetingConfig: 'Targeting',

  // Ad fields
  adType: 'Ad Type',
  businessName: 'Business Name',
  callToActionText: 'Call to Action',
  descriptions: 'Descriptions',
  destinationUrl: 'Destination URL',
  gti: 'GTI',
  headlines: 'Headlines',
  longHeadlines: 'Long Headlines',
  refTag: 'Ref Tag',

  // ADSP concept fields
  language: 'Language',
  gtiSet: 'GTI Set',
  schedule: 'Schedule',
  conceptKey: 'Concept Key',

  // ADSP creative fields
  creativeType: 'Creative Type',
  clickthroughUrl: 'Clickthrough URL',
  creativeTier1: 'Creative Tier 1',
  creativeTier2: 'Creative Tier 2',
  creativeTier3: 'Creative Tier 3',
  creativeTier4: 'Creative Tier 4',
  wildcard: 'Wildcard',
  include: 'Include',

  // Asset fields
  assetType: 'Asset Type',
  assetUrl: 'Asset URL',
  placement: 'Placement',
  description: 'Description',
  adSize: 'Ad Size',

  // Common / structural
  campaignId: 'Campaign ID',
  createdAt: 'Created',
  updatedAt: 'Updated',
  publisherEntityId: 'Publisher Entity ID',
  sourceEntityId: 'Source Entity ID',
  productStrategyId: 'Product Strategy ID',
  parentPublisherEntityId: 'Parent Publisher Entity ID',
  parentSourceEntityId: 'Parent Source Entity ID',
  parentEntityType: 'Parent Entity Type',
  syncStatus: 'Sync Status',
  entityStatus: 'Entity Status',
  lastError: 'Last Error',

  // Google-specific nested
  DISCOVER: 'Discover',
  GMAIL: 'Gmail',
  YOUTUBE: 'YouTube',
  YOUTUBE_VIDEO: 'YouTube Video',
};

/**
 * Returns the friendly label for a metadata key, or the raw key if no mapping exists.
 */
export function getFieldLabel (key: string): string {
  return METADATA_FIELD_LABELS[key] ?? key;
}
